export const GOOGLE_MAP_LIBRARIES = ['places', 'marker']; // add 'geometry', 'drawing' if needed
export const GOOGLE_MAPS_MAP_ID = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || '';